import Vue from 'vue';
import Service from './service';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_LOADED = 'UPDATE_LOADED';
export const UPDATE_AJDS = 'UPDATE_AJDS';
export const saveAjdAction = 'saveAjdAction';
export const initModuleAction = 'initModuleAction';
export default {
  namespaced: true,
  state: {
    error: '',
    loaded: false,
    types: {},
    ajds: [],
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'types', {});
      Vue.set(state, 'loaded', false);
      Vue.set(state, 'error', '');
      Vue.set(state, 'ajds', []);
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [UPDATE_LOADED](state, payload) {
      Vue.set(state, 'loaded', payload);
    },
    [UPDATE_AJDS](state, payload) {
      state.ajds.push(payload);
    },
  },
  actions: {
    [initModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
      return Service.getAllAjds()
        .then(list => list.forEach(ajd => commit(UPDATE_AJDS, ajd)))
        .then(() => commit(UPDATE_LOADED, true));
    },
    [saveAjdAction]({ commit, dispatch }, payload) {
      let promise = null;
      if ('id' in payload && payload.id !== 'dummy') {
        promise = Service.updateAjd(payload);
      } else if ('id' in payload && payload.id === 'dummy') {
        promise = Service.saveAjd(payload);
      } else {
        promise = Promise.reject('Incorrect data to save');
      }
      return promise.then(() =>
        dispatch('initModuleAction'));
    },
  },
  getters: {
    loaded: state => state.loaded,
    ajds: state => state.ajds,
  },
};



// WEBPACK FOOTER //
// ./src/features/ajd/store.js